import type { FC } from 'react';
import { VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, Text } from '../../../../../ui-components';

interface PasswordResetSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PasswordResetSuccessModal: FC<PasswordResetSuccessModalProps> = ({
    isOpen,
    onClose,
}) => (
    <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Success!"
        id="account-login-reset-password-success-modal"
        containerStyle={{ padding: '0 1rem 1rem 1rem' }}
    >
        <VStack spacing={4} width="100%" align="start">
            <Text id="account-reset-password-success-message">
                <FormattedMessage
                    id="account.reset-password.success_message"
                    defaultMessage="Password reset was successful."
                />
            </Text>
            <Button
                variant="primary-black"
                wide
                id="account-reset-password-login-button"
                onClick={onClose}
            >
                <FormattedMessage id="account.reset-password.login" defaultMessage="Sign In" />
            </Button>
        </VStack>
    </Modal>
);
